import {Injectable, OnDestroy} from '@angular/core';
import {CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router} from '@angular/router';
import {Observable, Subscription, combineLatest} from 'rxjs';
import {filter, map, tap, take} from 'rxjs/operators';
import { AuthService } from './auth.service';
import * as _ from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  //   return combineLatest(this.auth.userProfile$.pipe(filter(user => user !== null)), this.auth.isAuthenticated$).

  constructor(private auth: AuthService,
              private router: Router) {
  }

  canActivate1(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean|UrlTree> | boolean {
    console.log('canActivate');
    return this.auth.isAuthenticated$.pipe(
      tap(loggedIn => {
        if (!loggedIn) {
          this.auth.login(state.url);
        }
      })
    );
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> {
    console.log('canActivate');
    // return combineLatest(this.auth.userProfile$.pipe(filter (user => user !== null)),
    return combineLatest([this.auth.getUser$(), this.auth.isAuthenticated$]).pipe(
      map(combined => {
        const isLoggedIn = combined[1];

        if (!isLoggedIn) {
          console.log('no logged in');
          this.auth.login(state.url);
          return false;
        } else {
          const user = combined[0];
          const roles = user['http://gradientai.com/roles'];
          const isUserAllowed: boolean = _.intersection(route.routeConfig.data.allowedRoles, roles).length > 0;
          if (!isUserAllowed) {
            console.log('not allowed');
            this.router.navigate(['']);
          }
          else {
            console.log('Allowed');
          }
          return isUserAllowed;
        }
      })
    );
  }

}
